<template>
  <div v-if="person" data-name="testimonial-item" :class="$style.wrapper">
    <div data-name="container" :class="$style.container">
      <div data-name="profile" :class="$style['image-container']">
        <img :class="$style.image" :src="person.image" :aria-label="person.name + ' profile'" :alt="person.name + ' profile'" />
      </div>
      <div data-name="name" :class="$style['name-container']">
        <h2 :class="$style.name">{{ person.name }}</h2>
      </div>

      <div data-name="quote" :class="$style['quote-container']">
        <p v-html="person.content"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['person']
};
</script>
<style lang="scss" module>
@import '../assets/css/globals.scss';
.wrapper {
  padding-bottom: 40px;
  margin-bottom: 40px;
  clear: both;

  border-bottom: 2px solid rgba($black, 0.1);

  @include large {
    padding-bottom: 80px;
    margin-bottom: 80px;
  }
}

.container {
  padding-left: 40px;
  padding-right: 40px;

  @include large {
    padding-left: 0;
    padding-right: 0;
  }
}

.name-container {
  text-align: center;
}
.name {
  font-weight: 600;
}

.image-container {
  display: block;
  overflow: hidden;
  width: 130px;
  height: 130px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 130px;
  border: 10px solid $white;
}

.image {
  display: block;
  width: 100%;
}

.quote-container {
  color: $emperor;
  line-height: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/TestimonialItem.vue